import React from 'react';
import { BaseSlider, type BaseSliderProps } from './BaseSlider';

export type SliderProps = BaseSliderProps;

export const Slider: React.FC<SliderProps> = (props) => (
  <BaseSlider {...props} />
);
